import { Box, Theme, useMediaQuery } from "@material-ui/core";
import { FC } from "react";

import ErrorCatcher from "./ErrorCatcher";

const FormWrapper: FC<FormWrapperProps> = ({ width = "50%", children }) => {
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <ErrorCatcher>
      <Box p={isMd ? "" : "1em"} width={isMd ? "95%" : width} minWidth={isMd ? "auto" : 600}>
        {children}
      </Box>
    </ErrorCatcher>
  );
};

interface FormWrapperProps {
  width?: string;
}

export default FormWrapper;
